<template>
  <div class="mx-2 mx-md-4 mx-3 payment">
    <div class="bg-white border-radius--light py-2">
      <div class="row">
        <div class="col-md-2 mb-3">
          <em class="fas fa-file-invoice-dollar text-orange mr-2" />
          <span>Detalles de Pago</span>
        </div>
        <div class="col-md-12">
          <div class="bg-secondary-9 rounded p-md-3 p-2">
            <div class="row bg-white m-1 p-3 rounded">
              <div class="col-6 col-md-2">
                <total-amount-view
                  :amount="getAmount(value.totalAttendedAmt)"
                  :amount-class="amountClass(value.totalAttendedAmt)"
                  class="payment__total-amount-view"
                  icon="fa fa-usd-circle"
                  icon-color="color-yellow-star"
                  title="Subtotal de Asistencias:"
                />
              </div>
              <div class="col-6 col-md-2">
                <total-amount-view
                  :amount="getAmount(value.previousYearAdjustmentAmt)"
                  :amount-class="amountClass(value.previousYearAdjustmentAmt)"
                  class="payment__total-amount-view"
                  icon="fa fa-usd-circle"
                  icon-color="color-secondary-16"
                  title="Ajuste Automático Año Previo:"
                />
              </div>
              <div class="col-6 col-md-2">
                <total-amount-view
                  :amount="getAmount(value.automaticAdjustmenAmt)"
                  :amount-class="amountClass(value.automaticAdjustmenAmt)"
                  class="payment__total-amount-view"
                  icon="fa fa-usd-circle"
                  icon-color="color-secondary-30"
                  title="Total de Ajuste Automático:"
                />
              </div>
              <div class="col-6 col-md-2">
                <total-amount-view
                  :amount="getAmount(value.manualAdjustmentAmt)"
                  :amount-class="amountClass(value.manualAdjustmentAmt)"
                  class="payment__total-amount-view"
                  icon="fa fa-usd-circle"
                  icon-color="color-secondary-30"
                  title="Total de Ajuste Manual:"
                />
              </div>
              <div
                class="payment__total-to-pay col-md-2 border-left d-flex justify-content-end"
              >
                <total-amount-view
                  :amount="getAmount(value.costTotalAmt)"
                  amount-class="font-22 color-secondary-31"
                  class="payment__total-amount-view"
                  icon="fa fa-usd-circle"
                  icon-color="color-secondary-25"
                  title="Total a pagar:"
                />
              </div>
            </div>
            <div class="payment__footer-days row pr-0 pt-3 ml-md-4 ml-2">
              <div class="payment__footer-days col-md-3 col-4 pl-md-5">
                <div>
                  <span
                    class="payment__footer-days__label font-14 font-weight-normal color-secondary-6"
                  >
                    Número de Jornal:
                  </span>
                  <p
                    class="payment__footer-days__date font-16 font-weight-normal color-black font-weight-bold"
                  >
                    {{
                      status != assistanceApprovalStatus.Denegado &&
                      value.paymentJournalNumber != null
                        ? value.paymentJournalNumber
                        : '-'
                    }}
                  </p>
                </div>
              </div>
              <div class="payment__footer-days col-md-3 col-3">
                <div>
                  <span
                    class="payment__footer-days__label font-14 font-weight-normal color-secondary-6"
                  >
                    Fecha de pago:
                  </span>
                  <p
                    class="payment__footer-days__date font-16 font-weight-normal color-black font-weight-bold"
                  >
                    {{
                      status != assistanceApprovalStatus.Denegado
                        ? getDate(value.paymentDate)
                        : '-'
                    }}
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-4 px-0 px-md-3 d-flex justify-content-end"
              >
                <div
                  class="payment__footer-days__card bg-white rounded p-3 w-25 d-flex flex-column justify-content-center align-items-center m-1"
                >
                  <div
                    class="payment__footer-days__label color-gray-6 font-14 font-weight-bold"
                  >
                    Cumplimiento de Pago:
                  </div>
                  <div
                    class="badge badge-pill badge-primary p-md-2"
                    :class="{
                      'bg-secondary-32':
                        value.daysForPaymentStatusCode ===
                          daysForPaymentStatusEnum.Normal ||
                        value.daysForPaymentStatusCode ===
                          daysForPaymentStatusEnum.Unset,
                      'bg-green':
                        value.daysForPaymentStatusCode ===
                        daysForPaymentStatusEnum.Good,
                      'bg-primary-17':
                        value.daysForPaymentStatusCode ===
                        daysForPaymentStatusEnum.Exceeded,
                    }"
                  >
                    <span
                      class="payment__footer-days__date font-14 font-weight-bold mx-2"
                    >
                      {{
                        value.daysForPayment !== null
                          ? value.daysForPayment + ' días '
                          : '-'
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <payment-additional-list
      class="my-4"
      :items="additionalPayments"
      @on-delete="$emit('on-delete', $event)"
    />

    <payment-relationship-list
      class="my-4"
      :payment-journal="value"
      :value="paymentRelationship"
      @on-delete-relation="$emit('on-delete-relation', $event)"
    />
  </div>
</template>

<script>
import TotalAmountView from '@/views/provider/billingHistory/components/TotalAmountView.vue';
import PaymentAdditionalList from './PaymentAdditionalList';
import PaymentRelationshipList from './PaymentRelationshipList';
import assistanceApprovalStatus from '@/utils/constants/assistanceApprovalStatus.js';
import daysForPaymentStatus from '@/utils/constants/daysForPaymentStatus.js';

export default {
  name: 'Payment',
  components: {
    TotalAmountView,
    PaymentAdditionalList,
    PaymentRelationshipList,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    additionalPayments: {
      type: Array,
      required: true,
    },
    paymentRelationship: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Number,
      required: true,
    },
  },
  computed: {
    amountClass() {
      return (total) =>
        Math.sign(total) > 0
          ? 'font-18 color-gray-7'
          : 'font-18 color-secondary-28';
    },
    getAmount() {
      return (value) => (value ? this.$options.filters.price(value) : '-');
    },
    getDate() {
      return (value) => (value ? this.$options.filters.date(value) : '-');
    },
    assistanceApprovalStatus() {
      return assistanceApprovalStatus;
    },
    daysForPaymentStatusEnum() {
      return daysForPaymentStatus;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@media only screen and (max-width: 768px) {
  span,
  p {
    font-size: map-get($fontsSize, 'font-12') !important;
  }

  ::v-deep {
    .total-amount-view {
      &__title,
      &__amount {
        font-size: 10px !important;
      }

      &__amount {
        font-size: 13px !important;
      }

      &__icon {
        width: 15px;
        font-size: 16px;
      }
    }

    .payment__total-to-pay {
      border-left: none !important;
      border-top: 1px solid #dee2e6 !important;
      margin-top: 1em;
      padding-top: 1em;
    }
  }

  .payment__footer-days {
    padding: 0 !important;
    margin-right: 5px;

    &__label {
      font-size: 8px !important;
    }

    &__date {
      font-size: 9px !important;
    }

    &__card {
      width: 100% !important;
    }
  }
}
</style>
